import React from 'react';

const ForWhoSection = () => {
  const cards = [
    {
      title: 'НАЧИНАЮЩИЕ МАГАЗИНЫ',
      text: 'Запустим продажи на маркетплейсах под ключ, сопроводим на всех этапах работы и обучим Вашу команду работе на площадке',
    },
    {
      title: 'ТЕ КТО МАСШТАБИРУЕТСЯ',
      text: 'Сделаем так, что бы ваш бизнес вырос кратно: покажем проверенную стратегию продвижения, сделаем контент и обучим вашу команду.',
    },
    {
      title: 'БРЕНДЫ И КОМПАНИИ',
      text: 'Отладим BU Marketplace и усилим бизнес-процессы внутри вашей команды. Подберем нужную автоматизацию.',
    },
  ];

  return (
    <section
      className="forwho-section"
      style={{
        background: '#0F0F1A',
        padding: '80px 0',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Декоративные иконки на фоне */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: 'none',
          zIndex: 0,
        }}
      >
        <img
                loading="lazy"
          src="/images/icons/rocket.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '90px',
            height: '90px',
            top: '10%',
            left: '4%',
            transform: 'rotate(-15deg)',
            opacity: 0.06,
            filter: 'blur(2px) brightness(2)',
            animation: 'floatForWho1 6s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/chart.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '85px',
            height: '85px',
            top: '15%',
            right: '5%',
            transform: 'rotate(12deg)',
            opacity: 0.06,
            filter: 'blur(2px) brightness(2)',
            animation: 'floatForWho2 7s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/star.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '80px',
            height: '80px',
            bottom: '12%',
            left: '6%',
            transform: 'rotate(8deg)',
            opacity: 0.06,
            filter: 'blur(2px) brightness(2)',
            animation: 'floatForWho3 5.5s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/trophy.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '75px',
            height: '75px',
            bottom: '18%',
            right: '4%',
            transform: 'rotate(-10deg)',
            opacity: 0.06,
            filter: 'blur(2px) brightness(2)',
            animation: 'floatForWho4 6.5s ease-in-out infinite',
          }}
        />
      </div>

      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 24px',
          position: 'relative',
          zIndex: 1,
        }}
      >
        {/* Заголовок */}
        <div
          className="forwho-header"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '24px',
            marginBottom: '48px',
          }}
        >
          {/* Badge */}
          <span
            style={{
              background: 'rgba(255, 255, 255, 0.1)',
              color: '#FFFFFF',
              fontSize: '14px',
              fontWeight: 500,
              padding: '12px 24px',
              borderRadius: '50px',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
            }}
          >
            ДЛЯ КОГО
          </span>

          {/* Заголовок */}
          <h2
            style={{
              fontSize: '42px',
              fontWeight: 800,
              color: '#FFFFFF',
              textTransform: 'uppercase',
              margin: 0,
            }}
            className="forwho-title"
          >
            НАШИ КЛИЕНТЫ ЭТО
          </h2>
        </div>

        {/* Карточки */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '24px',
          }}
          className="forwho-grid"
        >
          {cards.map((card, index) => (
            <div
              key={index}
              className="forwho-card"
              style={{
                background: 'rgba(255, 255, 255, 0.05)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '24px',
                padding: '32px',
                transition: 'all 0.3s ease',
                position: 'relative',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(34, 211, 238, 0.2), 0 0 60px rgba(236, 72, 153, 0.15)';
                e.currentTarget.style.borderColor = 'rgba(34, 211, 238, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.1)';
              }}
            >
              <h3
                style={{
                  fontSize: '24px',
                  fontWeight: 700,
                  color: '#FFFFFF',
                  textTransform: 'uppercase',
                  marginBottom: '16px',
                  lineHeight: 1.2,
                }}
              >
                {card.title}
              </h3>
              <p
                style={{
                  fontSize: '16px',
                  fontWeight: 400,
                  color: 'rgba(255, 255, 255, 0.7)',
                  lineHeight: 1.6,
                  margin: 0,
                }}
              >
                {card.text}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Анимации */}
      <style>
        {`
          @media (max-width: 768px) {
            .forwho-header { flex-direction: column !important; align-items: flex-start !important; gap: 12px !important; }
            .forwho-title { font-size: 28px !important; }
            .forwho-grid { grid-template-columns: 1fr !important; gap: 16px !important; }
            .forwho-card { padding: 24px !important; border-radius: 16px !important; }
            .forwho-card h3 { font-size: 18px !important; }
            .forwho-card p { font-size: 14px !important; }
            .forwho-section { padding: 50px 0 !important; }
            .forwho-bg-icon { display: none !important; }
          }
          @media (max-width: 480px) {
            .forwho-title { font-size: 24px !important; }
            .forwho-section { padding: 40px 0 !important; }
          }

          @keyframes floatForWho1 {
            0%, 100% { transform: translate(0, 0) rotate(-15deg); }
            50% { transform: translate(-10px, -12px) rotate(-15deg); }
          }

          @keyframes floatForWho2 {
            0%, 100% { transform: translate(0, 0) rotate(12deg); }
            50% { transform: translate(10px, -15px) rotate(12deg); }
          }

          @keyframes floatForWho3 {
            0%, 100% { transform: translate(0, 0) rotate(8deg); }
            50% { transform: translate(-12px, -10px) rotate(8deg); }
          }

          @keyframes floatForWho4 {
            0%, 100% { transform: translate(0, 0) rotate(-10deg); }
            50% { transform: translate(15px, -14px) rotate(-10deg); }
          }
        `}
      </style>
    </section>
  );
};

export default ForWhoSection;
